var $14f44f430d85943b$exports = {};
$14f44f430d85943b$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Vybrat\xfd d\xe1tum`,
            other: `Vybrat\xe9 d\xe1tumy`
        })}: nedostupn\xe9.`
};


export {$14f44f430d85943b$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
